<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 搜索表单 -->
      <a-form layout="inline" style="margin-bottom: 24px">
        <a-form-item label="商家名称">
          <a-input v-model="query.merchantName" placeholder="请输入商家名称" allow-clear style="width: 200px" />
        </a-form-item>
        <a-form-item label="时间范围">
          <a-range-picker v-model="dateRange" style="width: 300px" @change="handleDateChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </a-form-item>
      </a-form>

      <!-- 概览卡片 -->
      <a-row :gutter="[16, 16]" style="margin-bottom: 24px">
        <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="stat-card">
            <a-statistic
              title="商家总数"
              :value="overview.totalMerchantCount"
              :precision="0"
            />
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="stat-card">
            <a-statistic
              title="平台采购总金额(元)"
              :value="overview.totalPurchasePrice"
              :precision="2"
              prefix="¥"
            />
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="stat-card">
            <a-statistic
              title="商家拿货总金额(元)"
              :value="overview.totalMerchantAmountAmount"
              :precision="2"
              prefix="¥"
            />
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="stat-card">
            <a-statistic
              title="门店拿货总金额(元)"
              :value="overview.totalStoreCostAmount"
              :precision="2"
              prefix="¥"
            />
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="stat-card">
            <a-statistic
              title="总要货数量"
              :value="overview.totalPurchaseQuantity"
              :precision="0"
            />
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="stat-card">
            <a-statistic
              title="平台总利润(元)"
              :value="overview.totalPlatformProfit"
              :precision="2"
              prefix="¥"
              :value-style="{ color: '#52c41a' }"
            />
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="stat-card">
            <a-statistic
              title="商家总利润(元)"
              :value="overview.totalMerchantProfit"
              :precision="2"
              prefix="¥"
              :value-style="{ color: '#1890ff' }"
            />
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="stat-card">
            <a-statistic
              title="门店总利润(元)"
              :value="overview.totalStoreProfit"
              :precision="2"
              prefix="¥"
              :value-style="{ color: '#1846ff' }"
            />
          </a-card>
        </a-col>
      </a-row>

      <!-- 商家利润统计表 -->
      <a-card title="商家利润统计" :bordered="false">
        <a-table
          :columns="merchantProfitColumns"
          :data-source="merchantProfitList"
          :loading="loading"
          :pagination="{
            current: query.pageNo,
            pageSize: query.pageSize,
            total: total,
            showSizeChanger: true,
            showTotal: total => `共 ${total} 条`
          }"
          size="small"
          rowKey="merchantId"
          @change="handleTableChange"
        >
          <template slot="purchaseAmount" slot-scope="text">
            <span v-if="text !== null && text !== undefined && text !== ''">
              ¥{{ typeof text === 'number' ? text.toFixed(2) : parseFloat(text).toFixed(2) }}
            </span>
            <span v-else>¥0.00</span>
          </template>
          <template slot="merchantPrice" slot-scope="text">
            <span v-if="text !== null && text !== undefined && text !== ''">
              ¥{{ typeof text === 'number' ? text.toFixed(2) : parseFloat(text).toFixed(2) }}
            </span>
            <span v-else>¥0.00</span>
          </template>
          <template slot="storeCost" slot-scope="text">
            <span v-if="text !== null && text !== undefined && text !== ''">
              ¥{{ typeof text === 'number' ? text.toFixed(2) : parseFloat(text).toFixed(2) }}
            </span>
            <span v-else>¥0.00</span>
          </template>
          <template slot="salesAmount" slot-scope="text">
            <span v-if="text !== null && text !== undefined && text !== ''">
              ¥{{ typeof text === 'number' ? text.toFixed(2) : parseFloat(text).toFixed(2) }}
            </span>
            <span v-else>¥0.00</span>
          </template>
          <template slot="merchantProfit" slot-scope="text">
            <span :style="{ color: text >= 0 ? '#1890ff' : '#cf1322' }">
              ¥{{ typeof text === 'number' ? text.toFixed(2) : parseFloat(text).toFixed(2) }}
            </span>
          </template>
          <template slot="platformProfit" slot-scope="text">
            <span :style="{ color: text >= 0 ? '#1846ff' : '#cf1322' }">
              ¥{{ typeof text === 'number' ? text.toFixed(2) : parseFloat(text).toFixed(2) }}
            </span>
          </template>
          <template slot="storeProfit" slot-scope="text">
            <span :style="{ color: text >= 0 ? '#52c41a' : '#cf1322' }">
              ¥{{ typeof text === 'number' ? text.toFixed(2) : parseFloat(text).toFixed(2) }}
            </span>
          </template>
        </a-table>
      </a-card>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getPlatformProfitStatistics } from '@/api/retail/statistics'
import moment from 'moment'

export default {
  name: 'PlatformProfit',
  data() {
    return {
      dateRange: [],
      query: {
        merchantName: undefined,
        startDate: undefined,
        endDate: undefined,
        pageNo: 1,
        pageSize: 10
      },
      overview: {
        totalMerchantCount: 0,
        totalPurchaseQuantity: 0,
        totalPurchasePrice: 0,
        totalPlatformRevenue: 0,
        totalMerchantAmountAmount: 0,
        totalMerchantProfit: 0,
        totalPlatformProfit: 0,
        totalStoreProfit: 0
      },
      merchantProfitList: [],
      loading: false,
      total: 0,
      merchantProfitColumns: [
        { title: '商家名称', dataIndex: 'merchantName', width: 150, align: 'center' },
        { title: '门店数量', dataIndex: 'storeCount', width: 100, align: 'center' },
        { title: '要货单数', dataIndex: 'purchaseOrderCount', width: 100, align: 'center' },
        { title: '要货数量', dataIndex: 'purchaseQuantity', width: 100, align: 'center' },
        // { title: '要货总金额(元)', dataIndex: 'purchaseAmount', width: 120, align: 'center', scopedSlots: { customRender: 'purchaseAmount' } },
        { title: '平台采购价(元)', dataIndex: 'purchasePrice', width: 120, align: 'center', scopedSlots: { customRender: 'purchaseAmount' } },
        { title: '商家成本价(元)', dataIndex: 'merchantPrice', width: 130, align: 'center', scopedSlots: { customRender: 'merchantPrice' } },
        { title: '门店成本价(元)', dataIndex: 'storeCost', width: 120, align: 'center', scopedSlots: { customRender: 'storeCost' } },
        { title: '门店销售价(元)', dataIndex: 'salesAmount', width: 120, align: 'center', scopedSlots: { customRender: 'salesAmount' } },
        { title: '平台利润(元)', dataIndex: 'platformProfit', width: 120, align: 'center', scopedSlots: { customRender: 'platformProfit' } },
        { title: '商家利润(元)', dataIndex: 'merchantProfit', width: 120, align: 'center', scopedSlots: { customRender: 'merchantProfit' } },
        { title: '门店利润(元)', dataIndex: 'storeProfit', width: 120, align: 'center', scopedSlots: { customRender: 'storeProfit' } },
        { title: '最后要货时间', dataIndex: 'lastPurchaseTime', width: 180, align: 'center' }
      ]
    }
  },
  mounted() {
    this.loadStatistics()
  },
  methods: {
    loadStatistics() {
      this.loading = true
      getPlatformProfitStatistics(this.query).then(response => {
        console.log('平台利润统计数据:', response)
        this.merchantProfitList = response.data?.records || []
        this.total = response.data?.total || 0
        // 确保概览数据不为null
        const overview = response.data?.overview
        if (overview) {
          this.overview = {
            totalMerchantCount: overview.totalMerchantCount || 0,
            totalPurchaseQuantity: overview.totalPurchaseQuantity || 0,
            totalPurchasePrice: overview.totalPurchasePrice || 0,
            totalPlatformRevenue: overview.totalPlatformRevenue || 0,
            totalMerchantAmountAmount: overview.totalMerchantAmountAmount || 0,
            totalStoreCostAmount: overview.totalStoreCostAmount || 0,
            totalStoreSalesAmount: overview.totalStoreSalesAmount || 0,
            totalMerchantProfit: overview.totalMerchantProfit || 0,
            totalPlatformProfit: overview.totalPlatformProfit || 0,
            totalStoreProfit: overview.totalStoreProfit || 0
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleDateChange(dates, dateStrings) {
      this.query.startDate = dateStrings[0]
      this.query.endDate = dateStrings[1]
    },
    handleSearch() {
      this.query.pageNo = 1
      this.loadStatistics()
    },
    handleReset() {
      this.query = {
        merchantName: undefined,
        startDate: undefined,
        endDate: undefined,
        pageNo: 1,
        pageSize: 10
      }
      this.dateRange = []
      this.loadStatistics()
    },
    handleTableChange(pagination) {
      this.query.pageNo = pagination.current
      this.query.pageSize = pagination.pageSize
      this.loadStatistics()
    }
  }
}
</script>

<style scoped>
.stat-card {
  margin-bottom: 0;
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-card >>> .ant-statistic-title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}

.stat-card >>> .ant-statistic-content {
  font-size: 24px;
  font-weight: 600;
}
</style>
